export default "__VITE_ASSET__AcQ_drmT__"